export function getFilesGalleryActiveEntry(files, index) {
  return { id: files[index]?.id ?? null, index }
}

// A removed active id settles on the neighbour that took its slot
export function getFilesGallerySettledEntry(files, active) {
  const foundIndex = files.findIndex(file => file.id === active.id)

  return foundIndex === -1
    ? getFilesGalleryActiveEntry(
        files,
        Math.min(active.index, Math.max(files.length - 1, 0))
      )
    : { id: active.id, index: foundIndex }
}

export function isSameFilesGalleryEntry(entry, otherEntry) {
  return entry.id === otherEntry.id && entry.index === otherEntry.index
}
